import { gql } from '@apollo/client'

export const ExportSection = gql`
    mutation exportSection($exportSectionInput: ExportSectionInput!) {
        exportProjectProductFamily(input: $exportSectionInput) {
            downloadURL
            errorMessage
            fileType
        }
    }
`
